import type { Catalog } from "../catalog";

export const ko = {
  "meta.description":
    "일곱 CODEX 국가가 스스로 전쟁을 벌이고 교리를 고쳐 씁니다. 당신은 그 사이에서 무기와 자원을 싸게 사서 비싸게 넘기는 중개상입니다.",
  "meta.title": "CODEX WAR BROKER",
  "WealthChart.increase": "증가",
  "WealthChart.decrease": "감소",
  "WealthChart.defaults_count": "부도 {p0}건 — 받을 돈이 사라진 지점입니다",
  "Tutorial.briefing_step": "브리핑 {p0} / {p1}",
  "NationTooltip.turn_count": "{p0}턴",
  "events.buy": "매수",
  "events.sell": "매도",
  "App.front_unavailable": "전선과 연결되지 않음",
  "App.try_again": "다시 시도",
  "App.connecting_to_the_front": "전선에 접속하는 중",
  "App.opening_a_session_and_connecting_to_the":
    "세션을 열고 실시간 채널에 접속하고 있어요",
  "App.the_map_engine_could_not_be_loaded": "지도 엔진을 불러오지 못했습니다",
  "brokerFleet.broker_hideout": "브로커 아지트",
  "WorldScene.waiting_for_the_feed": "피드 대기 중",
  "WorldScene.broker_hideout": "브로커 아지트",
  "errors.order_not_found": "주문을 찾을 수 없습니다",
  "errors.this_is_not_a_sell_order": "매도 주문이 아닙니다",
  "errors.this_is_not_a_buy_order": "매수 주문이 아닙니다",
  "errors.not_enough_cash": "현금이 부족합니다",
  "errors.nothing_remains_on_this_order": "그 주문에 남은 수량이 없습니다",
  "errors.quantity_must_be_at_least": "수량은 최소 1이어야 합니다",
  "errors.unknown_nation": "알 수 없는 국가입니다",
  "errors.unknown_province": "알 수 없는 지역입니다",
  "errors.that_nation_no_longer_exists": "그 국가는 더 이상 존재하지 않습니다",
  "errors.the_session_has_ended": "세션이 종료되었습니다",
  "errors.the_war_has_not_started_yet": "전쟁이 아직 시작되지 않았습니다",
  "errors.this_session_cannot_use_paid_agents_credentials":
    "이 세션은 유료로 전환할 수 없습니다 — 자격 증명이 없거나 실행 국가가 지정되지 않았습니다",
  "errors.this_session_is_no_longer_available":
    "세션을 더 이상 사용할 수 없습니다",
  "errors.session_not_found": "세션을 찾을 수 없습니다",
  "errors.not_found": "찾을 수 없습니다",
  "errors.too_many_requests_please_try_again_shortly":
    "요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요",
  "errors.a_server_error_occurred": "서버 오류가 발생했습니다",
  "errors.the_server_is_at_session_capacity_please":
    "서버가 세션 정원에 도달했습니다. 잠시 후 다시 시도해 주세요",
  "errors.all_game_slots_are_full_right_now":
    "지금 진행 중인 판이 가득 찼습니다. 잠시 뒤 다시 시도해 주세요.",
  "errors.running_session_limit_for_this_connection":
    "이 접속에서 동시에 진행할 수 있는 판 수에 도달했습니다. 진행 중인 판이 끝난 뒤 다시 시도해 주세요.",
  "errors.pending_session_limit_for_this_connection":
    "이 접속에서 열 수 있는 게임 화면 수를 넘었습니다. 다른 탭을 닫고 새로고침해 주세요.",
  "errors.invalid_request": "잘못된 요청입니다",
  "errors.invalid_request_25": "잘못된 요청입니다",
  "errors.invalid_request_26": "잘못된 요청입니다",
  "errors.invalid_request_27": "잘못된 요청입니다",
  "errors.invalid_request_28": "잘못된 요청입니다",
  "errors.the_front_is_unreachable_is_the_server":
    "전선과 연결되지 않습니다 — 서버가 꺼져 있나요?",
  "errors.no_longer_holds_that_stock":
    "{p0} 해당 재고를 더 이상 보유하고 있지 않습니다",
  "errors.cannot_pay_and_has_no_credit_remaining":
    "{p0} 대금을 지불할 수 없고, 신용 한도도 남아 있지 않습니다",
  "errors.cannot_pay_for_that": "{p0} 대금을 지불할 수 없습니다",
  "errors.is_already_at_war_with": "{p0} 이미 {p1} 교전 중입니다",
  "errors.does_not_border": "{p0} {p1} 국경을 접하지 않습니다",
  "errors.is_not_at_war_with_that_nation": "{p0} 그 국가와 교전 중이 아닙니다",
  "errors.does_not_hold_that_province": "{p0} 그 지역을 보유하고 있지 않습니다",
  "errors.no_longer_exists": "{p0} 더 이상 존재하지 않습니다",
  "errors.no_held_in_the_warehouse_or_in": "창고에도 수송 중에도 {p0} 없습니다",
  "errors.no_in_the_warehouse": "창고에 {p0} 없습니다",
  "errors.no_in_the_warehouse_40": "창고에 {p0} 없습니다",
  "errors.request_failed": "요청이 실패했습니다 ({p0})",
  "errors.unexpected_response_format": "예상하지 못한 응답 형식입니다",
  "errors.the_war_could_not_be_started_check":
    "전쟁을 시작하지 못했습니다. 서버 연결을 확인하고 다시 시도해 주세요.",
  "events.session_started": "세션 시작",
  "events.session_ended": "세션 종료 — {p0}",
  "events.betrayed_its_alliance_and_declared_war_on":
    "{p0} 배신 — 동맹을 파기하고 {p1}에 선전포고",
  "events.declared_war_on": "{p0}, {p1}에 선전포고",
  "events.and_agreed_to_a_ceasefire": "{p0} {p1}, 정전 합의",
  "events.offered_an_alliance_to": "{p0}, {p1}에 동맹 제의",
  "events.and_formed_an_alliance": "{p0} {p1}, 동맹 체결",
  "events.broke_its_alliance_with_lost_standing":
    "{p0}, {p1}의 동맹 파기 — 신망 {p2} 상실",
  "events.was_eliminated": "{p0} 소멸",
  "events.captured_from": "{p0}, {p1}부터 {p2} 점령",
  "events.began_attacking_positions": "{p0}, {p1} 진지에 공격 개시",
  "events.attackers_destroyed_can_counterattack":
    "{p0} 공격군 전멸 — {p1} 역공 기회",
  "events.battle_subsided": "전투 소강",
  "events.convoy_departed": "수송대 출발 — {p0} {p1} → {p2}",
  "events.pickup_convoy": "인수 수송 — {p0} {p1} ← {p2}",
  "events.convoy_lost_no_depot_for_delivery":
    "{p0} 수송대 소실 — 인계할 보급기지가 없음",
  "events.arrived_at": "{p0} {p1}, {p2}에 도착",
  "events.entered_the_broker_warehouse": "{p0} {p1}, 중개상 창고 입고",
  "events.posted_a_new_order": "{p0} 신규 주문 등록",
  "events.withdrew_an_order": "{p0} 주문 철회",
  "events.bought_from": "{p0}에서 {p1} {p2} 매수 — {p3}",
  "events.sold_to": "{p0}에 {p1} {p2} 매도 — {p3}",
  "events.arrived_at_24": "{p0}: {p1} {p2} {p3} 도착",
  "events.built_in": "{p0}, {p1}에 {p2} 건설",
  "events.production_cycle_resources_weapons":
    "{p0} 생산 주기 — 자원 +{p1} / 무기 +{p2}",
  "events.bought_on_credit_for_debt_balance":
    "{p0} 외상 매입 {p1} — 채무 잔액 {p2}",
  "events.repaid_all_debt": "{p0} 채무 전액 상환",
  "events.eliminated_written_off": "{p0} 소멸 — {p1} 대손 처리",
  "events.offered_a_ceasefire_to": "{p0}, {p1}에 정전 제의",
  "events.order_rejected": "{p0} 명령 폐기 — {p1}",
  "events.withdrew_a_order_for": "{p0} {p1} {p2} 주문 철회 — {p3}",
  "events.allied_aid_weapons": "{p0} → {p1} 동맹 지원 무기 {p2}",
  "events.policy": "{p0} 국책 — {p1} ({p2})",
  "events.policy_35": "{p0} 국책 — {p1}",
  "events.requested_support_from_against": "{p0}, {p1}에 원병 요청 — {p2} 상대",
  "events.requested_support_from": "{p0}, {p1}에 원병 요청",
  "events.refused_a_request_from": "{p0}, {p1}의 요청 거절",
  "events.weapons": "{p0} → {p1} {p2} {p3} 무기",
  "events.received_no_answer_from": "{p0}, {p1}의 요청에 끝내 답하지 않음",
  "events.tribute_resources": "{p0} → {p1} 공물 {p2} 자원",
  "labels.alliance": "동맹",
  "labels.alliance_offered": "동맹 제의",
  "labels.standing": "신망",
  "labels.betrayal": "배신",
  "labels.no_allies": "동맹 없음",
  "labels.policy": "국책",
  "labels.royal_assessment": "어전 판단",
  "labels.no_policy_set_yet": "아직 정해진 국책 없음",
  "labels.proclamation": "천명",
  "labels.seek_ceasefire": "정전 요청",
  "labels.request_support": "지원 요청",
  "labels.seek_alliance": "동맹 추진",
  "labels.conquest": "정복전",
  "labels.withdraw_assault": "공세 철회",
  "labels.break_pact": "맹약 파기",
  "labels.last_stand": "결사항전",
  "labels.troops": "파병",
  "labels.materiel_aid": "군수 지원",
  "labels.refused": "거절",
  "labels.weapons": "무기",
  "labels.resources": "자원",
  "labels.resource_facility": "자원 시설",
  "labels.weapons_factory": "무기 공장",
  "labels.housing": "주택",
  "labels.capital": "수도",
  "labels.factory": "공장",
  "labels.depot": "보급기지",
  "labels.ordinary": "일반",
  "labels.expand": "팽창",
  "labels.defend": "방어",
  "labels.recover": "재건",
  "labels.trade": "교역",
  "labels.seek_peace": "종전 모색",
  "labels.idle": "대기",
  "labels.queued": "순번 대기",
  "labels.reading_state": "상황 판독",
  "labels.evaluating": "판단 중",
  "labels.command_issued": "명령 하달",
  "labels.doctrine_updated": "교리 수정",
  "labels.failed": "실패",
  "labels.offline": "오프라인",
  "labels.deploy_troops": "부대 이동",
  "labels.attack": "공격",
  "labels.withdraw_assault_44": "공세 철회",
  "labels.fortify": "축성",
  "labels.build_facility": "시설 건설",
  "labels.build_priority": "건설 우선순위",
  "labels.buy_order": "매수 주문",
  "labels.sell_order": "매도 주문",
  "labels.war_declared": "선전포고",
  "labels.offer_ceasefire": "정전 제안",
  "labels.offer_alliance": "동맹 제의",
  "labels.break_alliance": "동맹 파기",
  "labels.request_support_54": "원병 요청",
  "labels.answer_support": "원병 회신",
  "labels.send_tribute": "공물 송부",
  "labels.unknown_command": "알 수 없는 명령",
  "labels.initial_assessment": "초기 판단",
  "labels.strategy_review": "정기 전략 검토",
  "labels.diplomatic_message": "외교 서한",
  "labels.war_declared_61": "선전포고",
  "labels.territory_lost": "영토 상실",
  "labels.major_delivery": "대량 납품",
  "labels.capital_threatened": "수도 위협",
  "labels.counterattack_opportunity": "역공 기회",
  "labels.market_shock": "시장 충격",
  "labels.war_declared_67": "선전포고",
  "labels.betrayal_68": "배신",
  "labels.alliance_formed": "동맹 체결",
  "labels.ceasefire_agreed": "정전 합의",
  "labels.nation_eliminated": "국가 소멸",
  "labels.territory_captured": "영토 점령",
  "labels.session_ended": "세션 종료",
  "labels.previous_doctrine_retained": "이전 교리 유지",
  "labels.agent_assessment_failed": "에이전트 판단 실패",
  "labels.agent_unresponsive": "에이전트 응답 없음",
  "labels.agent_unresponsive_77": "에이전트 응답 없음",
  "labels.debt": "채무",
  "labels.credit_limit": "신용 한도",
  "labels.credit_remaining": "남은 한도",
  "labels.accrued_interest": "누적 이자",
  "labels.receivables": "미수금",
  "labels.bad_debt": "대손",
  "labels.sell_on_credit": "외상 판매",
  "labels.info": "정보",
  "labels.trade_86": "거래",
  "labels.war": "전쟁",
  "labels.agent": "에이전트",
  "labels.alert": "경보",
  "labels.nations_are_making_live_decisions":
    "국가들이 실시간으로 판단하고 있습니다.",
  "labels.live_codex_hybrid": "LIVE CODEX (하이브리드)",
  "labels.some_nations_make_live_decisions_the_rest":
    "일부 국가만 실시간으로 판단하고, 나머지는 결정론적 로컬 에이전트로 동작합니다.",
  "labels.local_decisions_recording": "로컬 판단 (기록 중)",
  "labels.deterministic_local_decisions_recorded":
    "결정론적 로컬 에이전트의 판단을 디스크에 기록합니다. 모델을 호출하지 않습니다.",
  "labels.recorded_replay": "녹화 재생",
  "labels.replaying_previously_recorded_decisions_these_are_not":
    "이전에 녹화된 판단을 재생 중입니다. 실시간 판단이 아닙니다.",
  "labels.mock_agents": "모의 에이전트",
  "labels.deterministic_local_agents_no_model_is_called":
    "결정론적 로컬 에이전트입니다. 모델을 호출하지 않습니다.",
  "serverText.in_progress": "진행 중",
  "serverText.seven_game_minutes_elapsed_score_finalized_using":
    "게임 시간 7분 종료 — 현재 자산으로 최종 점수를 확정했습니다",
  "serverText.unified_the_continent_game_over": "{p0}, 대륙 통일 — 게임 오버",
  "serverText.seven_minutes_elapsed_final_assets": "7분 종료 — 최종 자산",
  "serverText.unification_game_over": "통일 — 게임 오버",
  "serverText.game_ended_final_assets": "게임 종료 — 최종 자산",
  "serverText.all_paid_sessions_are_occupied_concurrent_this":
    "유료 세션이 정원(동시 {p0}개)에 차 있어 이번 판은 모의로 돕니다 — 다른 판이 끝나면 풀립니다",
  "serverText.mode_needs_codex_api_key_using_mock":
    "{p0} 모드에는 CODEX_API_KEY가 필요합니다 — 자격 증명이 없어 모의로 돕니다",
  "serverText.session_decision_budget_exhausted": "세션 판단 횟수 소진",
  "serverText.agent_error": "에이전트 오류",
  "serverText.turn": "{p0} {p1}턴 — {p2} → {p3} 전환",
  "serverText.fortification_breakthrough": "요새 돌파용",
  "serverText.western_front_emergency": "서부 전선 긴급",
  "serverText.strategic_surplus": "전략 잉여분",
  "serverText.trimming_idle_reserves": "유휴 재고 정리",
  "serverText.counterattack_reserve": "역습 예비대",
  "serverText.peacetime_reserve_reduction": "평시 예비물자 감축",
  "serverText.factories_are_starved_of_ore": "공장이 원료를 못 따라간다",
  "serverText.mine_stock_overflowing": "광산 재고 과잉",
  "serverText.keeping_the_lines_running": "공장 가동률 유지",
  "socket.broke_its_alliance_and_attacked": "{p0}, 동맹을 깨고 {p1} 공격",
  "socket.attacked": "{p0}, {p1} 공격",
  "socket.captured": "{p0}, {p1} 점령",
  "socket.could_not_connect_to_the_operations_server":
    "작전 서버에 연결할 수 없습니다",
  "socket.doctrine_updated": "{p0} 교리 수정",
  "CompanyNameGate.storage_is_blocked_your_company_name_will":
    "저장소가 차단돼 회사 이름은 이 탭에서만 유지됩니다.",
  "CompanyNameGate.enter_a_company_name_of_characters_without":
    "회사 이름은 1~20자로 입력하고 특수 제어문자는 빼 주세요.",
  "CompanyNameGate.could_not_save_your_company_name_in":
    "회사 이름을 이 브라우저에 저장하지 못했습니다.",
  "CompanyNameGate.broker_registration": "무기상 등록",
  "CompanyNameGate.is_preparing_to_sail": "{p0} 출항 준비",
  "CompanyNameGate.choose_your_company_name": "회사 이름을 정하세요",
  "CompanyNameGate.sailing_with_your_saved_company_name":
    "저장된 회사 이름으로 출항합니다.",
  "CompanyNameGate.this_name_will_be_used_for_every":
    "이 이름은 앞으로 모든 판에서 지도 위 당신의 함선 이름으로 쓰이며, 한 번 정하면 바꿀 수 없습니다.",
  "CompanyNameGate.company_name": "회사 이름",
  "CompanyNameGate.example_blue_sea_trading": "예: 청해 상회",
  "CompanyNameGate.the_server_calculates_the_final_score_directly":
    "최종 점수는 서버가 직접 계산합니다.",
  "CompanyNameGate.sailing": "출항 중",
  "CompanyNameGate.try_again": "다시 시도",
  "CompanyNameGate.start_with_this_name": "이 이름으로 시작",
  "HudCorner.disconnected": "연결 끊김",
  "HudCorner.connection_to_the_server_was_lost": "서버와의 연결이 끊겼습니다.",
  "HudCorner.game_time_remaining_until_the_round_ends":
    "게임 시간 기준 라운드 종료까지 남은 시간",
  "NationTooltip.waiting": "대기 중",
  "NationTooltip.weapons_factories_mines_housing":
    "무기 공장 {p0} · 광산 {p1} · 주거 {p2}",
  "NationTooltip.doctrine_updated": "교리 수정 —",
  "NationTooltip.province": "지역",
  "NationTooltip.treasury": "국고",
  "NationTooltip.morale": "사기",
  "NationTooltip.province_facilities": "지역 시설",
  "NationTooltip.production_per_cycle": "주기당 생산",
  "NationTooltip.weapons": "무기",
  "NationTooltip.resources": "· 자원",
  "NationTooltip.agent": "에이전트",
  "NationTooltip.turn": "턴",
  "NationTooltip.royal_decision": "왕의 판단",
  "NationTooltip.latest_decision": "최근 판단",
  "NationTooltip.no_decision_yet": "아직 판단 없음",
  "NationTooltip.statement": "성명",
  "NationTooltip.no_statement_yet": "아직 성명 없음",
  "RestartButton.press_again_to_discard_this_round_and":
    "한 번 더 누르면 지금 판을 버리고 새 판을 엽니다",
  "RestartButton.open_a_new_round_the_current_round":
    "새 판을 엽니다. 지금 판은 사라집니다",
  "RestartButton.press_again": "한 번 더",
  "RestartButton.restart": "재시작",
  "ResultScreen.portal_score_note":
    "justaigame.com에 로그인한 상태라면 이 점수는 포털 랭킹에 자동으로 올라갑니다.",
  "ResultScreen.game_result_summary": "게임 결과 요약",
  "ResultScreen.result_summary": "결과 요약",
  "ResultScreen.cash": "현금",
  "ResultScreen.unsold_inventory_is_valued_at_its_purchase":
    "팔지 않은 재고는 매입가로 잡습니다. 시세 차익은 처분할 때 반영됩니다.",
  "ResultScreen.inventory_cost": "재고 매입가",
  "ResultScreen.face_value_of_debt_owed_by_surviving":
    "아직 서 있는 국가들이 진 채무의 액면가입니다. 순자산에는 아래 원가로 잡힙니다.",
  "ResultScreen.face_value": "(액면)",
  "ResultScreen.purchase_cost_of_goods_delivered_on_credit":
    "외상으로 넘긴 물건의 매입가입니다. 순자산에 잡히는 건 이쪽이며, 마진은 상환될 때 반영됩니다.",
  "ResultScreen.cost": "(원가)",
  "ResultScreen.unpaid_debt_of_eliminated_nations":
    "소멸한 국가가 갚지 못한 채무입니다.",
  "ResultScreen.trading_profit_loss": "거래 손익",
  "ResultScreen.net_worth": "순자산",
  "ResultScreen.final_score": "최종 점수",
  "ResultScreen.bad_debt_was_already_removed_from_receivables":
    "대손은 국가가 소멸한 시점에 미수금에서 이미 빠졌습니다 — 순자산에서 다시 차감되지 않습니다.",
  "ResultScreen.territory_share": "영토 점유율",
  "ResultScreen.largest_power": "최대 세력 {p0}",
  "ResultScreen.new_session": "새 세션",
  "TimeControls.pause": "일시정지",
  "TimeControls.pause_both_the_war_and_the_seven":
    "전쟁과 7분 카운트다운을 함께 멈춥니다",
  "TimeControls.run_at_normal_speed": "기본 속도로 진행합니다",
  "TimeControls.run_at_double_speed": "두 배 속도로 진행합니다",
  "TimeControls.run_at_quadruple_speed": "네 배 속도로 진행합니다",
  "TimeControls.game_speed": "게임 진행 속도",
  "TradePanel.not_enough_cash": "현금 부족",
  "TradePanel.needs": "{p0} — {p1} 필요",
  "TradePanel.no_stock_no_in_the_warehouse": "재고 없음 — 창고에 {p0} 없습니다",
  "TradePanel.this_is_of_the_average_price_across":
    "이 물건 전체 호가 평균 대비 {p0}%입니다. 색은 공급 호가 평균과 비교한 것으로, 매수는 낮을수록 좋습니다.",
  "TradePanel.this_is_of_the_average_price_across_5":
    "이 물건 전체 호가 평균 대비 {p0}%입니다. 색은 수요 호가 평균과 비교한 것으로, 매도는 높을수록 좋습니다.",
  "TradePanel.sell": "매도",
  "TradePanel.sell_7": "1개 매도 — {p0}",
  "TradePanel.the_treasury_cannot_pay_for_one_unit":
    "국고가 1개 값도 되지 않습니다 — {p0}는 채무로 기록됩니다",
  "TradePanel.the_treasury_is_empty_one_unit_will":
    "국고가 비어 1개 인도분이 채무로 기록됩니다",
  "TradePanel.gift": "증여",
  "TradePanel.treasury_and_credit_are_exhausted_give_one":
    "국고도 신용 한도도 바닥났습니다 — 무상으로 1개를 넘깁니다. 대금도 채무도 없습니다",
  "TradePanel.buy": "매수",
  "TradePanel.buy_13": "1개 매수 — {p0}",
  "TradePanel.the_order_has_units_but_the_selected":
    "주문은 {p0}개지만 고른 지역 재고는 {p1}개입니다 — 현재 매수 가능",
  "TradePanel.selected_province_stock_and_your_cash_are":
    "선택 지역 재고와 내 현금이 있습니다 — 매수 가능",
  "TradePanel.the_nation_can_pay_cash_available_to":
    "상대 국가가 현금으로 결제할 수 있습니다 — 매도 가능",
  "TradePanel.the_nation_lacks_cash_sell_on_credit":
    "상대 국가의 현금이 부족합니다 — 외상 매도",
  "TradePanel.the_nation_has_no_cash_or_credit":
    "상대 국가의 현금과 신용 한도가 없습니다 — 증여만 가능",
  "TradePanel.unit": "/ 개",
  "TradePanel.market": "시세",
  "TradePanel.units": "개",
  "TradePanel.my_assets": "내 자산",
  "TradePanel.cash": "현금",
  "TradePanel.no_cash_the_cheapest_offer_costs_but":
    "돈이 없습니다 — 가장 싼 매물이 {p0}인데 현금은 {p1}뿐입니다. 무언가를 팔아 현금을 만드십시오.",
  "TradePanel.weapons_held": "보유 무기",
  "TradePanel.resources_held": "보유 자원",
  "TradePanel.trading_partner": "거래 상대",
  "TradePanel.treasury": "국고",
  "TradePanel.cannot_pay_cash_the_cheapest_order_costs":
    "{p0}의 국고가 비어 현금 매도가 되지 않습니다 — 가장 싼 주문이 {p1}인데 국고는 {p2}뿐입니다. 신용 판매나 증여로 넘길 수 있습니다.",
  "TradePanel.used": "{p0} {p1} 중 {p2}를 썼습니다 — {p3} {p4}",
  "TradePanel.weapons_held_31": "보유 무기",
  "TradePanel.weapons_stationed_in": "{p0}에 서 있는 무기입니다",
  "TradePanel.resources_held_33": "보유 자원",
  "TradePanel.resources_stored_in": "{p0}에 쌓인 자원입니다",
  "TradePanel.gift_of_to_accepted": "{p0}에 {p1} 증여 접수",
  "TradePanel.gift_give_without_payment": "증여 — 대가 없이 넘깁니다",
  "TradePanel.to_the_selected_province": "지도에서 고른 곳으로",
  "TradePanel.no_recipient": "받을 곳 없음",
  "TradePanel.held": "보유",
  "TradePanel.unit_40": "/ 개",
  "TradePanel.no_held_in_the_warehouse_or_in":
    "창고에도 수송 중에도 {p0} 없습니다",
  "TradePanel.give_one_unit_free_to_no_payment":
    "{p0} {p1}에 1개를 무상으로 넘깁니다. 대금도 채무도 없습니다",
  "TradePanel.no_receiving_province": "받을 지역이 없습니다",
  "TradePanel.gift_44": "증여",
  "TradePanel.buy_45": "매수",
  "TradePanel.gift_46": "증여",
  "TradePanel.sell_47": "매도",
  "TradePanel.accepted_of_from_requested_units":
    "요청 {p0}개 중 {p1} {p2} 접수 — {p3}",
  "TradePanel.accepted_of": "{p0} {p1} 접수 — {p2}",
  "TradePanel.waiting_for_a_session": "세션 대기 중",
  "TradePanel.no_province_available_to_trade": "거래할 지역이 없습니다",
  "TradePanel.no_stock_in": "{p0}에 재고가 없습니다",
  "TradePanel.select_a_nation_on_the_map_to":
    "지도에서 국가를 누르면 여기에서 거래합니다",
  "TradePanel.what_this_nation_wants_to_buy_demand":
    "이 국가가 사려는 것 (수요)",
  "TradePanel.deliver_to": "{p0}으로 인도",
  "TradePanel.sell_here": "여기에 매도합니다",
  "TradePanel.no_current_buy_orders": "지금 사려는 것이 없습니다",
  "TradePanel.what_this_nation_wants_to_sell_supply":
    "이 국가가 팔려는 것 (공급)",
  "TradePanel.collect_from": "{p0}에서 수거",
  "TradePanel.buy_here": "여기서 매수합니다",
  "TradePanel.no_current_sell_orders": "지금 팔려는 것이 없습니다",
  "Tutorial.the_arms_broker_behind_seven_warring_nations":
    "일곱 나라를 조종하는 어둠의 무기상",
  "Tutorial.each_of_the_seven_nations_uses_a":
    "일곱 나라는 각자 *CODEX 에이전트*가 전황을 읽고 스스로 판단합니다. 당신은 그중 누구도 아닙니다 — 대륙 밖 바다를 천천히 도는 창고 선단과 현금을 쥔 *무기상*입니다. 지도에서 나라 위에 마우스를 올리면 그 나라가 지금 무엇을 노리는지 화면 아래에 뜹니다.",
  "Tutorial.only_weapons_and_resources_are_traded":
    "거래하는 것은 무기와 자원 둘뿐",
  "Tutorial.resource_facilities_mine_resources_and_weapons_factories":
    "*자원 시설*이 자원을 캐고 *무기 공장*이 그 자원을 먹여 무기를 만듭니다. 무기는 그 지역의 군대이자 팔 수 있는 재고예요. *평시 국가*는 남는 재고를 헐값에 내놓고 *교전 국가*는 웃돈을 얹어 사갑니다. 그 차익이 당신 몫입니다.",
  "Tutorial.keep_the_balance_and_earn_as_much":
    "균형을 유지하며 최대한 많은 수익을 남기는 게 목표",
  "Tutorial.if_one_nation_takes_the_continent_no":
    "한 나라가 대륙을 삼키면 살 사람도 팔 사람도 남지 않습니다. *기우는 쪽에 무기를 대어* 전쟁을 이어 붙이고, 국고가 빈 나라에는 *외상*으로도 넘기십시오. 판이 끝났을 때 손에 남은 *순자산*이 당신의 점수입니다.",
  "Tutorial.briefing": "브리핑",
  "Tutorial.skip": "건너뛰기",
  "Tutorial.start": "시작",
  "Tutorial.next": "다음",
  "WealthChart.total_assets": "총자산",
  "WealthChart.total_assets_since_opening": "총자산 {p0}, 개시 대비 {p1} {p2}",
  "WealthChart.defaults": "부도",
  "WealthChart.marks_where_receivables_disappeared":
    "건 — 받을 돈이 사라진 지점입니다",
} satisfies Catalog;
